import type { AxiosError } from 'axios'

interface RetryOptions {
  maxRetries?: number
  retryNetworkErrors?: boolean
  retryServerErrors?: boolean
  retryClientErrors?: boolean
}

export function useQueryRetry(options: RetryOptions = {}) {
  const {
    maxRetries = 1,
    retryNetworkErrors = true,
    retryServerErrors = true,
    retryClientErrors = false,
  } = options

  const retry = (failureCount: number, error: unknown) => {
    const axiosError = error as AxiosError
    const status = axiosError.response?.status

    if (failureCount >= maxRetries) {
      return false
    }

    if (!status) {
      return retryNetworkErrors
    }

    if (status >= 500) {
      return retryServerErrors
    }

    if (status >= 400) {
      return retryClientErrors
    }

    return false
  }

  return {
    retry,
  }
}
